import { IconType } from './custom-content.interface';

export enum ContentType {
  POST = 'POST',
  VIDEO = 'VIDEO',
  ALBUM = 'ALBUM',
  PRODUCT = 'PRODUCT',
  PROMOTION = 'PROMOTION',
  COLLECTIBLE = 'COLLECTIBLE',
  CUSTOM = 'CUSTOM',
}

export interface ContentTab {
  contentType: ContentType;
  name: string;
  id?: string;
  iconType?: IconType;
  order: number;
}
